import * as z from "zod";
import {CustomerResModel} from "./CustomerResModel";

const schema = z.object({
	content: z.array(CustomerResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerSearchResModel = {schema, model};
export type ICustomerSearchResModel = z.infer<typeof CustomerSearchResModel.model>;
export const DEFAULT_CUSTOMER_SEARCH_RES: ICustomerSearchResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
